import {
  Box,
  Button,
  CardActions,
  Grid,
  Stack,
  Tab,
  Tabs,
  Typography
} from '@mui/material';
import { MicrosoftExcel, Plus, Printer } from 'mdi-material-ui';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { apiService } from '../../../api/axiosClient';
import Page from 'src/components/Page';
import PageHeader from 'src/components/page-header';
import { getOrderNumbers } from 'src/utils/shop';
import MenuSimple from 'src/views/menu/MenuSimple';
import TableOrderManage from 'src/views/order/TableOrderManage';
import BoxWrapper from '../../../styles/BoxWrapper';
import { onStateUpdate } from '../../../utils/orderHandler';

const OrderManageList = () => {
  const [reload, setReload] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [filters, setFilters] = useState({});
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const getTabValue = (index) => {
    switch(index) {  
      case 1:
        return '주문완료';
      default:
        return '신규주문';
    }
  }

  useEffect(() => {
    setFilters({
      ...filters,
      order_status: getTabValue(tabIndex)
    });

    setReload(reload => reload + 1);
  }, [tabIndex]);

  const sheetDownload = async () => {
      await apiService.get('/proc/ordermanage/excel', {
          params: {
              ...filters
          },
          responseType: 'blob'
      }).then(response => {
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "주문관리리스트.xlsx";
          document.body.appendChild(a);
          a.click();
      }).catch(error => {
          console.error(error)
      });
  }

  const onStateChange = async (status) => {
    selected.map((data) => {
      onStateUpdate(data, status, () => {
        toast.success('수정 되었습니다');
      });
    });

    setReload(reload => reload + 1);
  }

  return (
    <Page title="주문관리">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 2}}>
                <Typography variant='h5' color='#666CFF'>
                  주문관리
                </Typography>
            </Stack>
          }
          subtitle={
            <Typography variant='body2'>
              주문관리 리스트를 보여줍니다.
            </Typography>
          }
        />
        <BoxWrapper>
          <Box sx={{ width: '100%', typography: 'body1' }}>            
            <MenuSimple setFilters={setFilters} setReload={setReload} />
          </Box>

          <Tabs 
            value={tabIndex} 
            onChange={(e, newValue) => setTabIndex(newValue)}
          >
            <Tab label="신규주문" />
            <Tab label="주문완료" />
          </Tabs>        

          <TableOrderManage filters={filters} submit={reload} selected={selected} setSelected={setSelected}
            page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />

          <CardActions className='card-action-dense'>
            <Stack direction="row" spacing={2}>
              <Link to={`/admin/process/order/register`}>
                  <Button variant="contained" startIcon={<Plus />}>등록</Button>
              </Link>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Button variant='contained' color="warning" onClick={() => {onStateChange("주문취소")}}>주문취소</Button>
              <Button variant='contained' color="warning" onClick={() => {onStateChange("주문완료")}}>주문완료</Button>          
              <Button variant='contained' color="warning" onClick={() => {onStateChange("신고관리")}}>신고관리</Button>
            </Stack>
            <Stack direction="row" spacing={2} sx={{pl: 4}}>          
              <Button component={Link} 
                to={`/form/order?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>거래명세</Button>
              <Button component={Link} 
                to={`/form/delivery?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>납품명세</Button>
              <Button component={Link} 
                to={`/form/spec?orderids=${getOrderNumbers(selected)}`} 
                target="_blank" 
                variant='contained' color='success' startIcon={<Printer />} disabled={selected.length === 0}>견적서</Button>
            </Stack>
            <Stack direction="row" spacing={2} sx={{pl: 4}}>
              <Button variant='contained' startIcon={<MicrosoftExcel />} onClick={sheetDownload}>엑셀출력</Button>
            </Stack>            
          </CardActions>
          
        </BoxWrapper>
      </Grid>
    </Page>
  )
}

export default OrderManageList